class LimitedQuantityPerOrderDialog extends HTMLDialogElement {
  constructor() {
    super();
  
    this.closeButton = this.querySelector('[data-dialog-close]');

    this.closeButton.addEventListener('click', e => {
      this.close();
    });
    
    this.addEventListener('click', e => {
      const dialogDimensions = this.getBoundingClientRect()
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        this.close()
      }
    });
  }
}

customElements.define('limited-quantity-per-order-dialog', LimitedQuantityPerOrderDialog, {extends: 'dialog'});